import React, { useState, useEffect } from 'react';
import axios from '../../api/axiosSuperAdmin';
import './SuperAdmin.css';

function SuperAdminDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/superadmin/dashboard')
      .then(res => setMetrics(res.data.data || res.data))
      .catch(err => setError(err.response?.data?.message || 'Failed to load metrics'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sa-loading">Loading dashboard...</div>;
  if (error) return <div className="sa-error">{error}</div>;

  const cards = [
    { label: 'Total Companies', value: metrics?.totalCompanies ?? '—', icon: '🏢' },
    { label: 'Pending Approvals', value: metrics?.pendingApprovals ?? '—', icon: '⏰' },
    { label: 'Active Trials', value: metrics?.activeTrials ?? metrics?.trialCompanies ?? '—', icon: '⏳' },
    { label: 'Active Subscriptions', value: metrics?.activeSubscriptions ?? metrics?.activeCompanies ?? '—', icon: '✅' },
    { label: 'Monthly Revenue', value: metrics?.monthlyRevenue != null ? `₹${metrics.monthlyRevenue.toLocaleString()}` : '—', icon: '💰' },
  ];

  return (
    <div className="sa-page">
      <h1 className="sa-title">Platform Overview</h1>

      <div className="sa-metrics-grid">
        {cards.map(card => (
          <div key={card.label} className="sa-metric-card">
            <span className="sa-metric-icon">{card.icon}</span>
            <div>
              <div className="sa-metric-value">{card.value}</div>
              <div className="sa-metric-label">{card.label}</div>
            </div>
          </div>
        ))}
      </div>

      {metrics?.recentSignups?.length > 0 && (
        <div className="sa-section">
          <h2>Recent Signups</h2>
          <table className="sa-table">
            <thead>
              <tr><th>Company</th><th>Plan</th><th>Status</th><th>Registered</th></tr>
            </thead>
            <tbody>
              {metrics.recentSignups.map(c => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.planTier}</td>
                  <td><span className={`sa-badge sa-badge-${c.status?.toLowerCase()}`}>{c.status}</span></td>
                  <td>{new Date(c.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SuperAdminDashboard;
